// This fun will help to remove `bundleCurrency` text till original value not come
removeDummyContent();

setTimeout(() => {
  const style = document.createElement('style');
  style.textContent = `
    #bundle-page-box {
      display: block !important;
    }
  `;
  document.head.appendChild(style);
}, 3000);

// REMOVE buildYourBoxBlock div
document.getElementById('buildYourBoxBlock').remove();
document.getElementById('customBundle').remove();

function manageCheckoutButton() {
  box_view = 'on_page'
  let selector, countSelector;

  if (box_view === 'on_page') {
    selector = '#page_view .product-check-box-event';
    countSelector = ".bundle-page-view [type='checkbox']:checked";
  } else if (box_layout === "card") {
    selector = '#dynamic__card-child-product .check-box-event';
    countSelector = ".product-card [type='checkbox']:checked";
  } else {
    selector = '#dynamic__child-product > tr > td > input';
    countSelector = ".index [type='checkbox']:checked";
  }

  function updateCheckoutButton() {
    const count = document.querySelectorAll(countSelector).length;
    let productQuantities = {};
    let bundle_details = fetchProductDetails();
    bundle_details.prod_id_arry.forEach(function (item) {
      productQuantities[item.id] = item.quantity;
    });

    let totalQuantity = 0;
    for (let id in productQuantities) {
      totalQuantity += parseInt(productQuantities[id], 10);
    }
    
    checkoutButtonManage(count, totalQuantity);
  }

  document.querySelectorAll(selector).forEach((input) => {
    input.addEventListener("change", updateCheckoutButton);
  });

  updateCheckoutButton();
}

// function removeDummyContent(){
//   console.log('-------- removeDummyContent ----');
//   const pageOriPrice = document.querySelector('.page-total-price')
//   var shopCurrency = window.ShopifyAnalytics.meta.currency;
//   const priceClass = document.querySelector('.product_original_price')
  
//   if (pageOriPrice) { pageOriPrice.innerHTML = '<span id="checkMarkPrice">' + shopCurrency + '&nbsp;'+ '</span>' }
//   if (priceClass) { priceClass.innerHTML = '<span class="currency">'+ shopCurrency +'</span>&nbsp;<span class="product_ori_price">0.0</span>' }
// }

function removeDummyContent() {
  var shopCurrency = 'Rs.';

  // Replace in all .page-total-price elements
  document.querySelectorAll('.page-total-price').forEach(function(el) {
    el.innerHTML = el.innerHTML.replace(/bundleCurrency/g, shopCurrency);
  });

  // Replace in all .page_discounted_price elements
  document.querySelectorAll('.page_discounted_price').forEach(function(el) {
    el.innerHTML = el.innerHTML.replace(/bundleCurrency/g, shopCurrency);
  });

  // Replace in all .product_original_price elements
  document.querySelectorAll('.product_original_price').forEach(function(el) {
    el.innerHTML = el.innerHTML.replace(/bundleCurrency/g, shopCurrency);
  });

  // Replace in all .page_discounted_price elements of total section
  document.querySelectorAll('.total-discount .page_discounted_price').forEach(function(el) {
    // el.innerHTML = el.innerHTML.replace(/bundleCurrency/g, shopCurrency);
    el.innerHTML = shopCurrency + '&nbsp;4170.00';
  });

  // Replace in all .page-total-price elements of total section
  document.querySelectorAll('.total-discount .page-total-price').forEach(function(el) {
    // el.innerHTML = el.innerHTML.replace(/bundleCurrency/g, shopCurrency);
    el.innerHTML = shopCurrency + '&nbsp;6600.00';
  });
}
